export default "__VITE_ASSET__rN6207qF__"